import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { getSiteConfig, SiteType } from '../libs/common/siteConfig';
import { getRoutePaths, getRedirects } from './routeRegistry';
import { LazyRoute } from './LazyRoute';

/**
 * Filesystem-based router that automatically generates routes
 * from the route registry
 */
export default function FilesystemRouter() {
  const history = useHistory();
  const siteConfig = getSiteConfig();
  const siteType = siteConfig.type;

  // Get all route paths for the current site type
  const routePaths = getRoutePaths(siteType);
  // Get redirect mappings from old paths to new paths
  const redirects = getRedirects(siteType);

  return (
    <Switch>
      {/* Redirect old paths to new normalized paths */}
      {Object.entries(redirects).map(([oldPath, newPath]) => (
        <Route key={oldPath} path={oldPath} exact>
          <Redirect to={newPath} />
        </Route>
      ))}
      {/* Regular routes */}
      {routePaths.map((path) => (
        <Route key={path} path={path}>
          <LazyRoute path={path} siteType={siteType} history={history} />
        </Route>
      ))}
      <Route path="/">
        <Redirect to={siteConfig.defaultRoute} />
      </Route>
    </Switch>
  );
}

